import Swiper from 'swiper';

export default function createSlider (container) {
  return new Swiper (container, {
    // ここからオプション
    loop: true,
    // effect: "fade",
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}